<template>
  <div>
    <div class="new-main-page">
      <h1 class="new-main-header">
        <img :src="theme.current.headerImage" alt="AI Logo" class="logo" />
      </h1>
      <div class="content">
        <div class="filter-container">
          <input
            type="text"
            v-model="filterQuery"
            placeholder="Filter"
            class="filter-input"
          />
          <select v-model="filterField" class="filter-dropdown">
            <option value="all">All</option>
            <option value="name">Name</option>
            <option value="start">Start</option>
            <option value="stage">Stage</option>
            <option value="end">End</option>
          </select>
        </div>
        <table class="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Start</th>
              <th>Stage</th>
              <th>End</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in filteredItems" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ formatDate(item.start) }}</td>
              <td>{{ item.stage }}</td>
              <td>{{ formatDate(item.end) }}</td>
              <td>
                <button @click="showOverlay" class="view-button">View</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="isOverlayVisible" class="overlay">
      <div class="overlay-content">
        <button @click="hideOverlay" class="close-button">&times;</button>
        <p>TBD</p>
      </div>
    </div>
  </div>
</template>

<script>
import { useThemeStore } from "@/stores/theme";

export default {
  name: "MonitorPage",
  setup() {
    const theme = useThemeStore();
    return { theme };
  },
  data() {
    return {
      filterQuery: "",
      filterField: "all",
      isOverlayVisible: false,
      items: [
        {
          id: 1,
          name: "John Doe",
          start: new Date(),
          stage: "Stage 1",
          end: new Date(),
        },
        {
          id: 2,
          name: "Jane Smith",
          start: new Date(),
          stage: "Stage 2",
          end: new Date(),
        },
        // Add more items as needed
      ],
    };
  },
  computed: {
    filteredItems() {
      if (this.filterField === "all") {
        return this.items.filter(
          (item) =>
            item.name.toLowerCase().includes(this.filterQuery.toLowerCase()) ||
            this.formatDate(item.start)
              .toLowerCase()
              .includes(this.filterQuery.toLowerCase()) ||
            item.stage.toLowerCase().includes(this.filterQuery.toLowerCase()) ||
            this.formatDate(item.end)
              .toLowerCase()
              .includes(this.filterQuery.toLowerCase()),
        );
      } else {
        return this.items.filter((item) =>
          this[this.filterField](item)
            .toLowerCase()
            .includes(this.filterQuery.toLowerCase()),
        );
      }
    },
  },
  methods: {
    showOverlay() {
      this.isOverlayVisible = true;
    },
    hideOverlay() {
      this.isOverlayVisible = false;
    },
    formatDate(date) {
      return date.toLocaleString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
    },
    name(item) {
      return item.name;
    },
    start(item) {
      return this.formatDate(item.start);
    },
    stage(item) {
      return item.stage;
    },
    end(item) {
      return this.formatDate(item.end);
    },
  },
};
</script>

<style scoped>
.new-main-page {
  display: flex;
  flex-direction: column;
  height: var(--app-height);
  min-height: 100vh;
  min-height: -webkit-fill-available;
  width: 100%;
  overflow: hidden;
}

.new-main-header {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  padding: 0;
  margin: 0;
  flex-shrink: 0;
}

.logo {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: #ffffffb2;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 20px;
  width: calc(100% - 40px);
  overflow-y: auto;
}

.filter-container {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.filter-input {
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.filter-input-old {
  width: 100%;
  padding: 8px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.filter-dropdown {
  margin-left: 10px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th,
.data-table td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: left;
}

.view-button {
  padding: 5px 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.view-button:hover {
  background-color: #0056b3;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay-content {
  position: relative; /* Ensure the close button is positioned relative to the overlay content */
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 300px; /* Set a fixed width for the overlay */
  height: 300px; /* Set a fixed height for the overlay */
  display: flex;
  justify-content: center;
  align-items: center;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .content {
    background-color: #e9e5d6;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
    margin: 0 auto;
    width: 100%;
    max-height: 100vh;
    overflow-y: auto;
    margin-left: 20px;
    border-radius: 10px;
    box-shadow: none;
    padding: 5%;
  }
  .data-table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
    border: none;
  }
  .new-main-page {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  .new-main-header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 5%;
    padding: 5;
    margin: 5;
    margin-top: 20px;
  }
  .new-main-page h1,
  .new-main-page p,
  .new-main-page form,
  .new-main-page div {
    width: 100vw;
    text-align: left;
  }
  .header {
    height: auto;
  }
  .logo {
    width: 100%;
    height: auto;
  }
}
</style>
